export const twitterGiveawayBG = require("./twitter_bg.png");
export const redditGiveawayBG = require("./reddit_bg.png");
export const dellImage = require("./image.png");
